const AutomationList = async () =>
    import('../../pages/automations/List').then((module) => ({
        Component: module.AutomationList,
    }));
const OrderRouting = async () =>
    import('../../pages/automations/OrderRouting/OrderRouting').then((module) => ({
        Component: module.OrderRouting,
    }));

const getAutomationRoutes = (_user) => {
    return [
        {
            path: '/automations/',
            lazy: AutomationList,
        },
        {
            path: '/automations/order-routing',
            lazy: OrderRouting,
        },
    ];
};

export { getAutomationRoutes };
